// extracted by mini-css-extract-plugin
export default {"fullpage":"loaderFullPage_fullpage__0lj54"};